import { render, staticRenderFns } from "./CartNavigation.vue?vue&type=template&id=2c9651e1&scoped=true&"
import script from "./CartNavigation.vue?vue&type=script&lang=js&"
export * from "./CartNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CartNavigation.vue?vue&type=style&index=0&id=2c9651e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9651e1",
  null
  
)

export default component.exports